import { z } from "zod";
import { IdentifiedOrDeletedAuthor } from "./author";

export const ClientFileReportType = z.enum(["benchmark", "budget"]);

export const ClientFileReport = z.object({
    id: z.number(),
    authorId: z.number(),
    type: ClientFileReportType,
    // The chip union (PRTL-1384); was a hand-rolled { name, avatar }.
    author: IdentifiedOrDeletedAuthor.nullable(),
    embeddedFiles: z.array(z.string()),
    title: z.string().nullish(),
    description: z.string().nullish(),
});
